import { Subject } from 'rxjs';

const subject = new Subject();

export const guestReviewerService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};